import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AuthenticationState } from './authentication.reducer';

export const getUserState =
  createFeatureSelector<AuthenticationState>('authentication');

export const getUser = createSelector(
  getUserState,
  (state: AuthenticationState) => state.user
);

export const getToken = createSelector(
  getUserState,
  (state: AuthenticationState) => state.user?.token
);

export const getisLoggedIn = createSelector(
  getUserState,
  (state: AuthenticationState) => state.isLoggedIn
);

export const getError = createSelector(
  getUserState,
  (state: AuthenticationState) => state.error
);

export const getCreatePassStatus = createSelector(
  getUserState,
  (state: AuthenticationState) => state.createPassMessage
);

export const getLoadingStatus = createSelector(
  getUserState,
  (state: AuthenticationState) => state.isLoading
);

export const getForgetPassStatus = createSelector(
  getUserState,
  (state: AuthenticationState) => state.forgotPass
);

export const getForgotPassLoading = createSelector(
  getUserState,
  (state: AuthenticationState) => state.forgotPassLoading
);
export const getVerifyOTPStatus = createSelector(
  getUserState,
  (state: AuthenticationState) => state.verifyOTP
);

export const getVerifyOTPLoading = createSelector(
  getUserState,
  (state: AuthenticationState) => state.verifyOTPLoading
);
export const getLoginState = createSelector(
  getUserState,
  (state: AuthenticationState) => state.isLoggingIn
);
